import { IdNameCacheSimpleInfoBase } from "../cache/id-name-simple-info.model";
import { ProcedureInstanceStateType } from "./procedure-instance-state-type.model";

export interface ProcedureInstanceCacheInfo {
	receptorEntity: IdNameCacheSimpleInfoBase
	promoterEntity: IdNameCacheSimpleInfoBase
	serviceName: IdNameCacheSimpleInfoBase
	procedureName: IdNameCacheSimpleInfoBase
}

export class ProcedureInstanceBase {

	id!: number;
	subject!: string
	procedureFormId!: number
	procedureInstanceCode!: number
	procedureName!: string //never comes in the procedures list
	promoterCreation!: boolean
	state!: number
	lastDate!: Date
  	normalizeLastDate!: string | null;
	signDate!: Date
	inputRegister!: string
	outputRegister!: string

	serviceInstanceId!: number
	serviceInstanceCode!: number

	//To and From
	promoterEntityId!: number
	receptorEntityId!: number

	//Relations
	servicePromoterId!: number  //changing the promoter then it gains visibility of all the registers done.

	//Only used for queries in the inbox?
	promoterOuId!: number
	receptorOuId!: number

	record!: string

	parentId!: number

	serviceName!: string //never comes in the procedures list
	procedureId!: number
	serviceId!: number

	receptorEntityName!: string //never comes in the procedures list
	promoterEntityName!: string //never comes in the procedures list

	textServiceInstanceId!: string //never comes in the procedures list
	textRegister!: string //never comes in the procedures list

	namesInfo!: ProcedureInstanceCacheInfo

    treatedUserEntityId!:number
    userTreatedName!:string | null

	isProcessed(): boolean {
		return this.state == ProcedureInstanceStateType.Processed
	}

	isDraft(): boolean {
		return this.state == ProcedureInstanceStateType.Draft
	}

	isEnQueue(): boolean {
		return this.state == ProcedureInstanceStateType.Enqueue
	}

	isPendingSign(): boolean {
		return this.state == ProcedureInstanceStateType.PendingSign
	}

	static from(source: ProcedureInstance): ProcedureInstanceBase {
		let current = new ProcedureInstanceBase();
		Object.assign(current, source)
		current.createFieldsNamesInfo()

		return current;
	}

	private createFieldsNamesInfo() {
		let promoter: IdNameCacheSimpleInfoBase = new IdNameCacheSimpleInfoBase();
		promoter.id = this.promoterEntityId;
		let receptor: IdNameCacheSimpleInfoBase = new IdNameCacheSimpleInfoBase();
		receptor.id = this.receptorEntityId;
		let service: IdNameCacheSimpleInfoBase = new IdNameCacheSimpleInfoBase();
		service.id = this.serviceId;
		let procedure: IdNameCacheSimpleInfoBase = new IdNameCacheSimpleInfoBase();
		procedure.id = this.procedureId;

		this.namesInfo = { promoterEntity: promoter, receptorEntity: receptor, serviceName: service, procedureName: procedure }
	}

}

export interface ProcedureInstance extends ProcedureInstanceBase {

}
